import React, { useEffect, useState, useRef } from "react";
import { Button, Card, Col, Modal, Row, Spinner } from "react-bootstrap";
import styles from "../onboard.module.css";
import {
  onBoardPersonalDetail,
  userSearch,
  fetchUser,
  statusApi,
  // onBoardOfflinePersonalDetail,
  saveBankDetail,
  onBoardingPersonalDetailUpdate,
} from "../../../api";
import { useMyContext } from "../../../myContext";
import VisitedStudent from "./visitedStudent";
import greentickmark from "../../signup/assets/greenTickIcon.svg";
// import addicon from "../../signup/assets/addFundsGrey.svg";
import Studentform from "./studentform";
import cross from "../../../public/assets/closeIcon.svg";
import AddIcon from "../../common/AddIcon";
import SearchableDropdown from "../../common/SearchableDropdown";
import moment from "moment/moment";
import StudentModal from "./StudentModal";

const StudentPersonalDetails = ({
  selectedRemitterData,
  stepToShow,
  setStepsToShow,
  studentList,
  shortDetail,
  setShortDetail,
  studentLoader,
  showStudentDetail,
  setShowStudentDetail,
  setShowPassportDetail,
  setReqDocs,
  studentCardSelection,
  setStudentCardSelection,
  addnewButton,
  fetchCardDetail,
  setUploadError,
}) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [postalCode, setPostalCode] = useState("");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [country, setCountry] = useState("India");
  const [dob, setDob] = useState("");
  const [passportname, setPassportName] = useState("");
  const [passportNo, setPassportNo] = useState("");
  const [passportIssueDate, setPassportIssueDate] = useState("");
  const [passportExpiryDate, setPassportExpiryDate] = useState("");
  const [placeOfIssue, setPlaceOfIssue] = useState("");
  const [emailError, setEmailError] = useState("");
  const [phoneNoError, setPhoneNoError] = useState("");
  const [passportError, setPassportError] = useState("");
  const [placeOfIssueError, setPlaceOfIssueError] = useState("");
  const [dobError, setDobError] = useState("");
  const [passIssueError, setPassIssueError] = useState("");
  const [postalError, setPostalError] = useState("");
  const [passExpiryError, setPassExpiryError] = useState("");
  const [loading, setLoading] = useState("");
  const [nextSectionError, setNextSectionError] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [showNextButton, setShowNextButton] = useState(true);
  const [panNumber, setPanNumber] = useState(null);
  const [valid, setIsValid] = useState({
    name: false,
    email: false,
    phoneNumber: false,
    postalCode: false,
    address: false,
    city: false,
    state: false,
    country: false,
    dob: false,
    passportname: false,
    passportNo: false,
    passportIssueDate: false,
    passportExpiryDate: false,
    placeOfIssue: false,
    remitterType: false,
    relation: false,
  });

  const [remitterType, setRemitterType] = useState("");
  const [relation, setRelation] = useState("");
  const [remitterTypeError, setRemitterTypeError] = useState("");
  const [relationError, setRelationError] = useState("");
  const [isFormDisabled, setIsFormDisabled] = useState(false);
  const [remitterTypeDisabled, setRemitterTypeDisabled] = useState(false);
  const [referenceNumber, setReferenceNumber] = useState("");
  const [mcaPullBeneficiaryData, setMcaPullBeneficiaryData] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedStudentName, setSelectedStudentName] = useState("");
  const [studentRelation, setStudentRelation] = useState(null);
  const [studentRelationError, setStudentRelationError] = useState("");
  const [studentRelationLoading, setStudentRelationLoading] = useState(false);
  const searchableDropdownRef = useRef(null);
  const [mcaPullStudentData, setMcaPullStudentData] = useState(null);

  useEffect(() => {
    if (referenceNumber) {
      if (selectedRemitterData.panNo === panNumber) {
        setRemitterType("Self");
        setRemitterTypeDisabled(true);
      } else {
        setRemitterType("Guardian");
        setRemitterTypeDisabled(true);
      }
    } else if (
      selectedRemitterData &&
      selectedRemitterData.fullName &&
      selectedRemitterData.dob
    ) {
      const remitterName = selectedRemitterData.fullName.toLowerCase().trim();
      const inputName = name.toLowerCase().trim();

      const remitterDob = moment(selectedRemitterData.dob, "YYYY-MM-DD");

      const inputDob = moment(dob, "DD/MM/YYYY");

      if (remitterName === inputName && remitterDob.isSame(inputDob, "day")) {
        setRemitterType("Self");
        setRemitterTypeDisabled(true);
      } else {
        setRemitterType("Guardian");
        setRemitterTypeDisabled(true);
      }
    } else {
      setRemitterType("");
      setRemitterTypeDisabled(false);
    }
  }, [name, dob, selectedRemitterData]);

  const {
    setStudentUserId,
    studentSecondFlow,
    setCompletedStudent,
    setStudentSecondFlow,
    setShowStudentUpload,
    themeColor,
    remitterUserId,
    setBeneficicaryUserId,
    studentUserId,
    mcaUserSearch,
    showStudentUpload,
    CountryMapping,
  } = useMyContext("");

  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const onHandleDate = (date, fieldName) => {
    const dateObject = new Date(date);
    const formattedDate = dateObject.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
    if (fieldName === "dateofBirth") {
      setDob(formattedDate);
    } else if (fieldName === "passportIssueDate") {
      setPassportIssueDate(formattedDate);
    } else if (fieldName === "passportExpiryDate") {
      setPassportExpiryDate(formattedDate);
    }
  };

  const ValidateEmail = (e) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (emailRegex.test(email)) {
      setEmailError("");
      return false;
    } else {
      return true;
    }
  };

  const validatePassport = (Number) => {
    var regex = new RegExp("^([A-Z][0-9]{7}|[A-Z]{2}[0-9]{6})$");
    if (regex.test(Number)) {
      return true;
    } else {
      return false;
    }
  };

  const compareDates = (date1, date2) => {
    const date1Array = date1.split("/");
    const date2Array = date2.split("/");
    const Date1 = new Date(date1Array[2], date1Array[1] - 1, date1Array[0]);
    const Date2 = new Date(date2Array[2], date2Array[1] - 1, date2Array[0]);
    return Date2 > Date1;
  };

  const parseDate = (value) => {
    const [day, month, year] = value.split("/");
    return `${year}/${month}/${day}`;
  };

  const handleBlur = (e) => {
    if (e.target.name === "email") {
      if (ValidateEmail() && email !== "") {
        setIsValid({ ...valid, email: true });
        setEmailError("Enter a valid email such as example@email.com");
      } else {
        setEmailError("");
        setIsValid({ ...valid, email: false });
      }
    } else if (e.target.name === "phoneNumber") {
      if (phoneNumber !== "" && phoneNumber.length < 10) {
        setIsValid({ ...valid, phoneNumber: true });
        setPhoneNoError("Phone Number should be 10 digit.");
      } else {
        setIsValid({ ...valid, phoneNumber: false });
        setPhoneNoError("");
      }
    } else if (e.target.name === "passportNo") {
      if (passportNo !== "" && !validatePassport(passportNo)) {
        setIsValid({ ...valid, passportNo: true });
        setPassportError("Enter a valid PassPort Number.");
      } else {
        setIsValid({ ...valid, passportNo: false });
        setPassportError("");
      }
    } else if (e.target.name === "Postal") {
      if (postalCode !== "" && postalCode.length < 6) {
        setIsValid({ ...valid, postalCode: true });
        setPostalError("Postal Code should be 6 digit.");
      } else {
        setIsValid({ ...valid, postalCode: false });
        setPostalError("");
      }
    } else if (e.target.name === "placeOfIssue") {
      if (placeOfIssue !== "" && placeOfIssue.trim().length < 2) {
        setIsValid({ ...valid, placeOfIssue: true });
        setPlaceOfIssueError("Place of issue must be at least 2 characters.");
      } else {
        setIsValid({ ...valid, placeOfIssue: false });
        setPlaceOfIssueError("");
      }
    }
  };

  const handleChange = (e) => {
    if (e.target.name === "name") {
      setName(e.target.value);
    } else if (e.target.name === "email") {
      setEmail(e.target.value);
    } else if (e.target.name === "phoneNumber") {
      if (phoneNumber.length === 0 && e.target.value === "0") {
        setPhoneNumber("");
      } else if (e.target.value === "" || e.target.value.length <= 10) {
        setPhoneNumber(e.target.value);
      }
    } else if (e.target.name === "Postal") {
      if (e.target.value === "" || e.target.value.length <= 6) {
        setPostalCode(e.target.value);
      }
    } else if (e.target.name === "Address") {
      setAddress(e.target.value);
    } else if (e.target.name === "City") {
      setCity(e.target.value);
    } else if (e.target.name === "State") {
      setState(e.target.value);
    } else if (e.target.name === "dob") {
      //   setDob(e.target.value);
    } else if (e.target.name === "Country") {
      setCountry(e.target.value);
    } else if (e.target.name === "passportName") {
      setPassportName(e.target.value);
    } else if (e.target.name === "passportNo") {
      setPassportNo(e.target.value);
    } else if (e.target.name === "placeOfIssue") {
      setPlaceOfIssue(e.target.value);
    }
  };

  const checkIfValid = () => {
    setDobError("");
    setPassIssueError("");
    setPassExpiryError("");
    setPlaceOfIssueError("");
    setNextSectionError("");
    setRemitterTypeError("");
    setRelationError("");

    // Check required fields
    if (name === "") {
      setIsValid({ ...valid, name: true });
      return;
    }
    if (email === "") {
      setIsValid({ ...valid, email: true });
      return;
    }
    if (phoneNumber === "") {
      setIsValid({ ...valid, phoneNumber: true });
      return;
    }
    if (postalCode === "") {
      setIsValid({ ...valid, postalCode: true });
      return;
    }
    if (address === "") {
      setIsValid({ ...valid, address: true });
      return;
    }
    if (city === "") {
      setIsValid({ ...valid, city: true });
      return;
    }
    if (state === "") {
      setIsValid({ ...valid, state: true });
      return;
    }
    if (dob === "") {
      setDobError("Please Select Date");
      return;
    }
    if (passportname === "") {
      setIsValid({ ...valid, passportname: true });
      return;
    }
    if (passportNo === "") {
      setIsValid({ ...valid, passportNo: true });
      return;
    }
    if (passportIssueDate === "") {
      setPassIssueError("Please Select Date");
      return;
    }
    if (passportExpiryDate === "") {
      setPassExpiryError("Please Select Date");
      return;
    }
    if (placeOfIssue === "") {
      setIsValid({ ...valid, placeOfIssue: true });
      return;
    }
    if (remitterType === "") {
      setIsValid({ ...valid, remitterType: true });
      setRemitterTypeError("Please select remitter type.");
      return;
    }
    if (remitterType === "Guardian" && relation === "") {
      setIsValid({ ...valid, relation: true });
      setRelationError("Please select relation.");
      return;
    }

    // Check validation errors
    if (
      emailError !== "" ||
      phoneNoError !== "" ||
      passportError !== "" ||
      postalError !== "" ||
      placeOfIssueError !== ""
    ) {
      setNextSectionError("Please fill all the required field correctly.");
      return;
    }

    // Check date validations
    if (!compareDates(dob, passportIssueDate)) {
      setNextSectionError("Dob should be greater than passportIssueDate.");
      return;
    }
    if (!compareDates(passportIssueDate, passportExpiryDate)) {
      setNextSectionError(
        "passportIssueDate should be greater than passportExpiryDate.",
      );
      return;
    }

    // All validations passed - reset validation state and call API
    setIsValid({
      name: false,
      email: false,
      phoneNumber: false,
      studentRelationship: false,
      postalCode: false,
      address: false,
      city: false,
      state: false,
      country: false,
      dob: false,
      passportname: false,
      passportNo: false,
      passportIssueDate: false,
      passportExpiryDate: false,
      placeOfIssue: false,
      remitterType: false,
      relation: false,
    });

    StudentDetailApi();
  };

  const createBeneficiary = async (body) => {
    const resp = await onBoardPersonalDetail(body);

    if (resp.status === 200 && resp.data && resp.data.data) {
      setBeneficicaryUserId(resp.data.data.userAccountId);
      const { beneficiaryBank } = mcaPullBeneficiaryData;
      const body = {
        accountHolderName: beneficiaryBank.accountHolderName,
        bankName: beneficiaryBank.bankName,
        accountNo: beneficiaryBank.accountNo,
        bankAccountType: beneficiaryBank.accountType.toLowerCase(),
        bankAddress: beneficiaryBank.bankAddress,
        branch: beneficiaryBank.branchName,
        swiftCode: beneficiaryBank.swiftCode,
        remarks: "added",
        currencyCode: "USD",
      };

      await saveBankDetail(body, resp.data.data.userAccountId);
    }
    try {
    } catch (error) {
      setLoading(false);
      setNextSectionError("something went wrong, please try again later.");
    }
  };

  const StudentDetailData = async () => {
    // const isUserAlreadyExists = studentList?.some(
    //   (student) => student.referenceNumber === referenceNumber
    // );
    // if (isUserAlreadyExists) {
    //   setNextSectionError(
    //     "A student with this reference number already exists. Please use different MCA account."
    //   );
    //   return;
    // }

    const body = {
      guardianId: remitterUserId,
      name: name,
      address: address,
      city: city,
      state: state,
      country: country,
      dob: parseDate(dob),
      postalCode: postalCode,
      email: email,
      phone: "+91" + phoneNumber,
      accountType: "Student",
      firstName: name,
      nameOnPassport: passportname,
      passportIssueDate: parseDate(passportIssueDate),
      passportExpiryDate: parseDate(passportExpiryDate),
      passportNo: passportNo,
      placeOfIssue: placeOfIssue,
      remitterType,
    };
    if (remitterType === "Guardian") {
      body.relation = relation;
    } else {
      body.relation = "SELF";
    }

    if (referenceNumber) {
      body.referenceNumber = referenceNumber;
    }

    try {
      setLoading(true);
      onBoardPersonalDetail(body).then((resp) => {
        setLoading(false);
        if (resp.status === 200 && resp.data && resp.data.data) {
          if (referenceNumber) {
            const body = {
              name: mcaPullBeneficiaryData.beneficiaryFullName,
              address: mcaPullBeneficiaryData.beneficiaryBank.bankAddress,
              city: "Singapore",
              state: "Singapore",
              country: "Singapore",
              postalCode: "018982",
              email: mcaPullBeneficiaryData.email,
              phone: mcaPullBeneficiaryData.phoneNumber,
              accountType: "beneficiary",
              firstName: mcaPullBeneficiaryData.beneficiaryFullName,
              referenceNumber: referenceNumber,
            };

            const findCountry = CountryMapping.find(
              (item) => item.name.toLowerCase() === "singapore",
            );

            let countryObjectInString = JSON.stringify(findCountry);
            sessionStorage.setItem("country", countryObjectInString);

            createBeneficiary(body);
          }

          if (remitterType === "Self") {
            checkStudentApproved(resp.data.data.userAccountId);
          } else {
            setReqDocs(["PAN", "Passport"]);
            setStepsToShow("StudentStep2");
          }
          setStudentUserId(resp.data.data.userAccountId);
          setStudentCardSelection(false);
          setShowStudentDetail(true);
          setStudentSecondFlow(true);
          setShowModal(false);
          setShortDetail({
            name: name,
            phone: phoneNumber,
            email: email,
            dob: dob,
            address: address,
            city: city,
            state: state,
            postalcode: postalCode,
            country: "India",
            remitterType: remitterType,
            relation: relation,
          });
          setName("");
          setEmail("");
          setPhoneNumber("");
          setPostalCode("");
          setAddress("");
          setCity("");
          setState("");
          setDob("");
          setPassportName("");
          setPassportNo("");
          setPassportIssueDate("");
          setPassportExpiryDate("");
          setPlaceOfIssue("");
        } else {
          setNextSectionError(
            resp && resp.data
              ? resp.data.message
              : "something went wrong, please try again later.",
          );
        }
      });
    } catch (error) {
      setLoading(false);
      setNextSectionError("something went wrong, please try again later.");
    }
  };

  const checkStudentApproved = (id) => {
    statusApi(id).then((res) => {
      setReqDocs([]);
      var documents = res.data.documents;
      try {
        const allDocsPresent =
          documents.PAN && documents.PASSPORT_FRONT && documents.PASSPORT_BACK;

        if (
          res.status === 200 &&
          Object.keys(documents).length === 3 &&
          allDocsPresent
        ) {
          setShowStudentUpload(false);
          setCompletedStudent(true);
          setStepsToShow("beneficiaryStep1");
        } else {
          if (Object.keys(documents).length !== 0) {
            const reqDocs = [];
            if (!documents.PAN) {
              reqDocs.push("PAN");
            }
            if (!documents.PASSPORT_FRONT) {
              reqDocs.push("Passport");
            }
            if (!documents.PASSPORT_BACK) {
              reqDocs.push("Passport");
            }
            setReqDocs(reqDocs);
            setShowStudentUpload(true);
          } else {
            const reqDocs = ["PAN", "Passport"];
            setReqDocs(reqDocs);
            setShowStudentUpload(true);
          }
          setStepsToShow("StudentStep2");
        }
      } catch (error) {
        setShowStudentUpload(true);
      }
    });
  };

  const StudentDetailApi = () => {
    StudentDetailData();
  };

  const handleChangeNew = (e) => {
    e.preventDefault();
    setStudentCardSelection(false);
    setStepsToShow("StudentStep1");
    setShowStudentUpload(true);
    setShowModal(true);
    setIsFormDisabled(false); // Enable the form for new entry
    setReferenceNumber("");
    setPanNumber(null);
  };

  const handleChangeBack = (e) => {
    e.preventDefault();

    // Clear all form data
    setName("");
    setEmail("");
    setPhoneNumber("");
    setPostalCode("");
    setAddress("");
    setCity("");
    setState("");
    setCountry("India");
    setDob("");
    setPassportName("");
    setPassportNo("");
    setPassportIssueDate("");
    setPassportExpiryDate("");
    setPlaceOfIssue("");
    setRemitterType("");
    setRelation("");

    // Clear errors
    setEmailError("");
    setPhoneNoError("");
    setPassportError("");
    setDobError("");
    setPassIssueError("");
    setPostalError("");
    setPassExpiryError("");
    setPlaceOfIssueError("");
    setRemitterTypeError("");
    setRelationError("");
    setNextSectionError("");

    // Reset validation state
    setIsValid({
      name: false,
      email: false,
      phoneNumber: false,
      postalCode: false,
      address: false,
      city: false,
      state: false,
      country: false,
      dob: false,
      passportname: false,
      passportNo: false,
      passportIssueDate: false,
      passportExpiryDate: false,
      placeOfIssue: false,
      remitterType: false,
      relation: false,
    });

    // Reset form disabled state
    setIsFormDisabled(false);

    fetchCardDetail();
    setShowStudentDetail(false);
    setStepsToShow("");
    setCompletedStudent(false);
    setShowPassportDetail(false);
    setShowModal(false);
    setUploadError("");
  };

  const handleClearAll = () => {
    // Clear all form data
    setName("");
    setEmail("");
    setPhoneNumber("");
    setPostalCode("");
    setAddress("");
    setCity("");
    setState("");
    setCountry("India");
    setDob("");
    setPassportName("");
    setPassportNo("");
    setPassportIssueDate("");
    setPassportExpiryDate("");
    // setRemitterType("");
    setRelation("");
    setReferenceNumber("");
    setPanNumber(null);

    // Clear errors
    setEmailError("");
    setPhoneNoError("");
    setPassportError("");
    setDobError("");
    setPassIssueError("");
    setPostalError("");
    setPassExpiryError("");
    setRemitterTypeError("");
    setRelationError("");
    setNextSectionError("");

    // Reset validation state
    setIsValid({
      name: false,
      email: false,
      phoneNumber: false,
      postalCode: false,
      address: false,
      city: false,
      state: false,
      country: false,
      dob: false,
      passportname: false,
      passportNo: false,
      passportIssueDate: false,
      passportExpiryDate: false,
      remitterType: false,
      relation: false,
    });

    // Reset form disabled state
    setIsFormDisabled(false);
    // setRemitterTypeDisabled(false);

    // Clear SearchableDropdown using ref
    if (searchableDropdownRef.current) {
      searchableDropdownRef.current.clearDropdown();
    }
  };

  // Transform studentList to the format expected by SearchableDropdown
  const [searchResults, setSearchResults] = useState([]);
  const transformedStudentList =
    (searchResults.length > 0 ? searchResults : studentList)?.map((student) => {
      return {
        value: student.userAccountId || student.erUserAccountId,
        label: student.email || student.fullName,
        email: student.email,
        accountNo:
          student.globalAccountNo ||
          student.erUserAccountId ||
          student.userAccountId,
        fullData: student,
      };
    }) || [];

  // Handler for API search with debounce
  const handleUserSearch = async (searchText) => {
    try {
      const partnerCode = sessionStorage.getItem("partnerShortCode");
      const appName = "MCA";

      if (!partnerCode) {
        console.error("Partner code not found in session");
        return;
      }

      const response = await userSearch(searchText, partnerCode, appName);

      if (
        response &&
        response.status === 200 &&
        response.data &&
        response.data.data
      ) {
        setSearchResults(response.data.data);
      } else {
        setSearchResults([]);
      }
    } catch (error) {
      console.error("Error searching users:", error);
      setSearchResults([]);
    }
  };

  const handleClearSearch = () => {
    setSearchResults([]);
  };

  // Handler for when a dropdown item is clicked
  const handleDropdownSelection = async (value, label, option) => {
    try {
      const appName = "MCA";
      const userId = option?.fullData?.userId || option?.value;
      setReferenceNumber(userId);

      if (!userId) {
        console.error("User ID not found in selected option");
        return;
      }

      const response = await fetchUser(userId, appName);

      if (
        response &&
        response.status === 200 &&
        response.data &&
        response.data.data
      ) {
        const studentData = response.data.data.student;
        setMcaPullStudentData(response.data.data.student);
        setMcaPullBeneficiaryData(response.data.data.beneficiary);
        // setMcaPullBeneficiaryData(response.data.data.beneficiary);
        // Format dates from YYYY-MM-DD to DD/MM/YYYY
        const formatDate = (dateStr) => {
          if (!dateStr) return "";
          const date = new Date(dateStr);
          const day = String(date.getDate()).padStart(2, "0");
          const month = String(date.getMonth() + 1).padStart(2, "0");
          const year = date.getFullYear();
          return `${day}/${month}/${year}`;
        };

        // Prefill form fields with fetched data
        setName(studentData.fullName || "");
        setEmail(studentData.emailId || "");
        setPhoneNumber(studentData.phoneNumber?.replace("+91", "") || "");
        setPostalCode(studentData.postalCode || "");
        setAddress(studentData.address || "");
        setCity(studentData.city || "");
        setState(studentData.state || "");
        setCountry(
          studentData.country === "IN"
            ? "India"
            : studentData.country || "India",
        );
        setDob(formatDate(studentData.dob));
        setPassportName(studentData.passportName || "");
        setPassportNo(studentData.passportNo || "");
        setPassportIssueDate(formatDate(studentData.passportIssueDate));
        setPassportExpiryDate(formatDate(studentData.passportExpiryDate));
        setPlaceOfIssue(studentData.placeOfIssue || "");
        setPanNumber(studentData.panNumber);

        // Open the form and disable student card selection
        setStudentCardSelection(false);
        setStepsToShow("StudentStep1");
        setShowModal(true);
        setIsFormDisabled(true); // Disable the form for prefilled data
      } else {
        console.error("Failed to fetch user data");
      }
    } catch (error) {
      console.error("Error fetching user:", error);
    }
  };
  // based on full name and dob  we have to make this state disabled  for this

  const handleRelationConfirm = async () => {
    setStudentRelationLoading(true);
    //handle error if there is no value
    if (!studentRelation) {
      setStudentRelationError("Please select relation.");
      return;
    }
    setStudentRelationError("");

    const payload = {
      remitterType: "Guardian",
      relation: studentRelation,
      remitterId: remitterUserId,
      userAccountId: studentUserId,
    };

    const res = await onBoardingPersonalDetailUpdate(payload);

    if (res && res.status === 200) {
      setShowStudentDetail(true);
      setStudentCardSelection(false);
      if (showStudentUpload === true) {
        setStepsToShow("StudentStep2");
      } else {
        setCompletedStudent(true);
      }
      setModalOpen(false);
      setStudentRelationLoading(false);
    } else {
      setStudentRelationError("Something went wrong, please try again later.");
    }
  };

  const isValidPurpose =
    sessionStorage.getItem("subPurpose") === "Blocked Account (Others)" ||
    sessionStorage.getItem("subPurpose") === "GIC (Canada)";

  return (
    <Card className={styles.cardAccount}>
      <Card.Body className={styles.cardBodyAccount}>
        <div className={styles.headingandbutton}>
          <Row className={styles.Title}>Personal Details</Row>
          {stepToShow === "StudentStep1" &&
            studentCardSelection === false &&
            studentSecondFlow === false && (
              <div className={styles.HeaderParentNew}>
                <SearchableDropdown
                  ref={searchableDropdownRef}
                  options={transformedStudentList}
                  label="Search student from Borderless Money"
                  enableApiSearch={true}
                  onSearch={handleUserSearch}
                  onClear={handleClearSearch}
                  onChange={handleDropdownSelection}
                />
              </div>
            )}

          {studentSecondFlow === true && studentLoader === false && (
            <>
              {studentCardSelection === true ? (
                <div
                  className={
                    mcaUserSearch && !isValidPurpose ? styles.HeaderParent : ""
                  }
                >
                  {mcaUserSearch && !isValidPurpose && (
                    <SearchableDropdown
                      ref={searchableDropdownRef}
                      options={transformedStudentList}
                      label="Search student from Borderless Money"
                      enableApiSearch={true}
                      onSearch={handleUserSearch}
                      onClear={handleClearSearch}
                      onChange={handleDropdownSelection}
                    />
                  )}
                  <div
                    className={styles.buttonaddnew}
                    onClick={handleChangeNew}
                  >
                    {/* <img src={addicon} alt=""></img> */}
                    <AddIcon color="#0061D3" />
                    Add new
                  </div>
                </div>
              ) : (
                <>
                  <div
                    className={
                      showStudentDetail === false
                        ? styles.buttonback
                        : styles.buttonEdit
                    }
                    onClick={handleChangeBack}
                  >
                    {showStudentDetail === true &&
                    (stepToShow === "StudentStep1" ||
                      stepToShow === "StudentStep2")
                      ? "Edit"
                      : stepToShow === "StudentStep1"
                        ? "Back"
                        : ""}
                  </div>
                </>
              )}
            </>
          )}
        </div>
        {studentLoader ? (
          <Spinner
            animation="border"
            className={styles.spinnerColorOutside}
            style={{ borderColor: themeColor, borderRightColor: "#eaecf0" }}
          />
        ) : (
          <>
            {showStudentDetail === true ? (
              <>
                <Row>
                  <Col md={11} sm={11} xs={10} className={styles.details}>
                    {shortDetail.name}, {shortDetail.phone}, {shortDetail.email}
                    , {shortDetail.dob}, {shortDetail.address},{" "}
                    {shortDetail.city}, {shortDetail.state},{" "}
                    {shortDetail.postalcode}, {shortDetail.country}
                  </Col>
                  <Col md={1} sm={1} xs={2} style={{ position: "relative" }}>
                    <img
                      className={styles.greentick}
                      src={greentickmark}
                      alt=""
                    />
                  </Col>
                </Row>
              </>
            ) : studentCardSelection === true ? (
              <VisitedStudent
                setSelectedStudentName={setSelectedStudentName}
                setModalOpen={setModalOpen}
                showStudentDetail={showStudentDetail}
                setShowStudentDetail={setShowStudentDetail}
                studentList={studentList}
                shortDetail={shortDetail}
                setShortDetail={setShortDetail}
                setStepsToShow={setStepsToShow}
                setReqDocs={setReqDocs}
                studentCardSelection={studentCardSelection}
                setStudentCardSelection={setStudentCardSelection}
              />
            ) : (
              <>
                {stepToShow === "StudentStep1" &&
                studentCardSelection === false ? (
                  <>
                    <div className={styles.showonWeb}>
                      <hr style={{ marginTop: "0px" }} />
                      <Studentform
                        placeOfIssueError={placeOfIssueError}
                        placeOfIssue={placeOfIssue}
                        mcaPullStudentData={mcaPullStudentData}
                        remitterTypeDisabled={remitterTypeDisabled}
                        remitterTypeError={remitterTypeError}
                        relationError={relationError}
                        remitterType={remitterType}
                        setRemitterType={setRemitterType}
                        relation={relation}
                        setRelation={setRelation}
                        name={name}
                        handleChange={handleChange}
                        email={email}
                        valid={valid}
                        handleBlur={handleBlur}
                        emailError={emailError}
                        phoneNumber={phoneNumber}
                        phoneNoError={phoneNoError}
                        postalCode={postalCode}
                        postalError={postalError}
                        address={address}
                        city={city}
                        state={state}
                        dob={dob}
                        onHandleDate={onHandleDate}
                        dobError={dobError}
                        passExpiryError={passExpiryError}
                        passIssueError={passIssueError}
                        passportError={passportError}
                        passportExpiryDate={passportExpiryDate}
                        passportIssueDate={passportIssueDate}
                        passportNo={passportNo}
                        passportname={passportname}
                        nextSectionError={nextSectionError}
                        checkIfValid={checkIfValid}
                        handleClearAll={handleClearAll}
                        loading={loading}
                        themeColor={themeColor}
                        isFormDisabled={isFormDisabled}
                      />
                    </div>
                    {screenWidth < 576 && (
                      <>
                        {addnewButton && (
                          <Row>
                            <Col
                              sm={6}
                              xs={6}
                              className={styles.nodatafoundStyling}
                            >
                              No Data Found
                            </Col>
                            <Col sm={6} xs={6}>
                              <Button
                                style={{
                                  margin: "10px 0px",
                                  display: "flex",
                                  alignItems: "center",
                                  fontSize: "14px",
                                }}
                                onClick={() => setShowModal(true)}
                              >
                                Add New
                              </Button>
                            </Col>
                          </Row>
                        )}
                        <Modal
                          show={stepToShow === "StudentStep1" && showModal}
                        >
                          <div style={{ padding: "20px" }}>
                            <Row>
                              <Col
                                md={9}
                                sm={9}
                                xs={9}
                                className={styles.Title}
                              >
                                Personal Details
                              </Col>
                              <Col
                                md={3}
                                sm={3}
                                xs={3}
                                onClick={
                                  addnewButton
                                    ? () => setShowModal(false)
                                    : handleChangeBack
                                }
                                style={{
                                  display: "flex",
                                  justifyContent: "flex-end",
                                  padding: "10px",
                                }}
                              >
                                <img src={cross} alt="nav-close" />
                              </Col>
                            </Row>
                            <hr style={{ marginTop: "0px" }} />
                            <Studentform
                              placeOfIssueError={placeOfIssueError}
                              placeOfIssue={placeOfIssue}
                              mcaPullStudentData={mcaPullStudentData}
                              remitterTypeDisabled={remitterTypeDisabled}
                              remitterTypeError={remitterTypeError}
                              relationError={relationError}
                              remitterType={remitterType}
                              setRemitterType={setRemitterType}
                              relation={relation}
                              setRelation={setRelation}
                              name={name}
                              handleChange={handleChange}
                              email={email}
                              valid={valid}
                              handleBlur={handleBlur}
                              emailError={emailError}
                              phoneNumber={phoneNumber}
                              phoneNoError={phoneNoError}
                              postalCode={postalCode}
                              postalError={postalError}
                              address={address}
                              city={city}
                              state={state}
                              dob={dob}
                              onHandleDate={onHandleDate}
                              dobError={dobError}
                              passExpiryError={passExpiryError}
                              passIssueError={passIssueError}
                              passportError={passportError}
                              passportExpiryDate={passportExpiryDate}
                              passportIssueDate={passportIssueDate}
                              passportNo={passportNo}
                              passportname={passportname}
                              nextSectionError={nextSectionError}
                              checkIfValid={checkIfValid}
                              handleClearAll={handleClearAll}
                              loading={loading}
                              themeColor={themeColor}
                              isFormDisabled={isFormDisabled}
                            />
                          </div>
                        </Modal>
                      </>
                    )}
                  </>
                ) : (
                  ""
                )}
              </>
            )}
          </>
        )}
      </Card.Body>
      <StudentModal
        studentRelationLoading={studentRelationLoading}
        isOpen={modalOpen}
        setStudentRelation={setStudentRelation}
        selectedStudentName={selectedStudentName}
        remitterName={selectedRemitterData.fullName}
        onRequestClose={() => setModalOpen(false)}
        onSubmit={handleRelationConfirm}
        studentRelationError={studentRelationError}
      />
    </Card>
  );
};

export default StudentPersonalDetails;
